import { useContext } from 'react';
import { Box } from '@mui/material';
import { AdviceContext } from '../../contexts';
import { Loading } from '../components';
import { UserAdvicesCard } from './componets/user-advices-card';

export const UserAdvicesCards = ({ temperature, userChildren }) => {
    const advices = useContext(AdviceContext);
    const weatherAdv = (temp) => advices.filter(adv => adv.maxT >= temp && temp >= adv.minT);
    const advice = (text) => weatherAdv(temperature).filter(({ age }) => age === text);

    return (
        <>
            {(!userChildren.length) ?
                <Loading /> :
                <div className='advices-wrapper'>
                    <h2 className='advices-wrapper_header'>Одяг для дитини:</h2>
                    {userChildren.map(child =>
                        <UserAdvicesCard
                            key={child.id}
                            child={child}
                            temperature={temperature}
                            advice={advice} />
                    )}
                    <Box>
                        <p>*Дані поради являються рекомендаціями. Тільки матір знає, як краще вдягнути своє дитя.</p>
                    </Box>
                </div >
            }
        </>
    )
}